export default "__VITE_ASSET__fbed7ea0__"